module.exports = __webpack_public_path__ + "img/notify1.f9e555b4.png";